import styled from "styled-components";

export const Container = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 2rem;
  background: radial-gradient(circle at top left, #0b0617, #000);
  color: white;
  position: relative;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;
export const ProfilePicWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff;
  margin: 0 auto 10px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);
  border: 4px solid rgba(61, 4, 126, 0.8);
`;
export const ProfileImg = styled.img`
  width: 90%;
  height: 90%;
  object-fit: cover;
`;
export const HeaderLogo = styled.img`
  height: 70px; /* adjust size */
  width: auto; /* maintain aspect ratio */
  object-fit: contain;
  cursor: pointer; /* makes it feel clickable */
  margin-left: 50px;
  @media (max-width: 768px) {
    height: 60px;
    margin-left: 30px;
  }
`;

// export const Container = styled.header`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   padding: 1rem 2rem;
//   background: linear-gradient(
//     to right,
//     rgb(16, 16, 16),
//     rgb(16, 16, 16),
//     rgb(34, 33, 33)
//   );
//   color: white;
//   position: fixed; /* 👈 makes it fixed */
//   top: 0; /* 👈 sticks it to the top */
//   left: 0;
//   width: 100%; /* 👈 full width */
//   z-index: 1000; /* 👈 ensures it stays on top */

//   @media (max-width: 768px) {
//     padding: 1rem;
//   }
// `;

export const Logo = styled.h1`
  font-size: 1.5rem;
  font-weight: bold;
  color: #fff;
`;

export const Nav = styled.nav`
  display: flex;
  gap: 2rem;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const AuthButtons = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 768px) {
    display: none;
  }
`;
export const AuthButtons2 = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 20px;
`;

export const MenuIcon = styled.div`
  display: none;
  font-size: 2rem;
  color: #fff;
  cursor: pointer;
  z-index: 1001;

  @media (max-width: 768px) {
    display: block;
  }
`;
export const SideMenuContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 0;
  width: 250px;
  height: 100vh;
  z-index: 999;
  padding: 24px 16px;
  flex-direction: column;
  gap: 16px;
`;

interface NavItemProps {
  active?: boolean;
}

export const NavItem = styled.a<NavItemProps>`
  color: ${(props) => (props.active ? "#a855f7" : "#fff")};
  font-weight: ${(props) => (props.active ? "600" : "400")};
  border-bottom: ${(props) => (props.active ? "2px solid #a855f7" : "none")};
  padding: 0.5rem 0;
  transition: color 0.3s ease, border-bottom 0.3s ease;
  text-decoration: none;
  &:hover {
    color: #a855f7;
  }
`;

interface SideNavItemProps {
  active?: boolean;
}
export const SideMenuItem = styled.div<SideNavItemProps>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0.8rem 1rem;
  border-radius: 6px;
  margin-top: 10px;
  cursor: pointer;
  text-decoration: none;
  color: ${(props) => (props.active ? "#a855f7" : "#fff")};
  background: ${(props) => (props.active ? "#1e1e2f" : "transparent")};
  font-weight: ${(props) => (props.active ? "600" : "400")};
  transition: all 0.3s ease;

  &:hover {
    background: #1e1e2f;
    color: #a855f7;
  }
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  z-index: 1001;
  cursor: pointer;

  svg {
    color: white; // or your primary color
  }
`;
export const SideMenu = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  width: 230px;
  background: radial-gradient(circle at top left, #0b0617, #000);
  z-index: 1000;
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  transition: transform 0.3s ease-in-out;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.4);
  z-index: 999;
`;

export const LoginButton = styled.button`
  margin-top: 20px;
  padding: 10px 16px;
  background-color: rgb(0, 0, 0); /* Purple */
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  width: 220px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #a855f7; /* lighter purple on hover */
  }
`;
export const SignupButton = styled.button`
  margin-top: 20px;
  padding: 10px 16px;
  border: 1px solid rgb(151, 151, 151); /* Purple border */
  background-color: transparent;
  color: rgb(255, 255, 255); /* Purple text */
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  width: 220px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f3e8ff; /* light purple background on hover */
    color: #7e22ce;
  }
`;

export const PrimaryButton = styled.button`
  padding: 14px 24px;
  background: #a855f7;
  border: none;
  border-radius: 12px;
  color: white;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: 0.3s ease-in-out;

  &:hover {
    background: #9333ea;
  }
`;

export const SecondaryButton = styled(PrimaryButton)`
  background: transparent;
  border: 1px solid rgba(147, 51, 234, 0.6);
  color: #fff;
  backdrop-filter: blur(4px);
  transition: all 0.3s ease-in-out;
  box-shadow: 0 0 0 rgba(147, 51, 234, 0);

  &:hover {
    background: rgba(147, 51, 234, 0.9);
    color: white;
    box-shadow: 0 0 20px rgba(147, 51, 234, 0.6);
    transform: translateY(-2px);
  }
`;
